import type React from "react";
import { useNavigate } from "react-router";

import ImageParty from "@/assets/images/party.png";
import type { ModalBaseProps } from "@/components/Modal/Modal";
import { Modal } from "@/components/Modal/Modal";
import { Button } from "@/design-system/Button";
import { useSlug } from "@/hooks/useSlug";
import { routes } from "@/routes";
import { useTranslation } from "@/translations";

type BookingSuccessModalProps = ModalBaseProps & {};

export function BookingSuccessModal({ isOpened, onOpenChange }: BookingSuccessModalProps): React.ReactNode {
  const slug = useSlug();
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Modal.Root size="md" title={t("page.bookings.book-asset.success-modal.title")} {...{ isOpened, onOpenChange }}>
      <Modal.Body>
        <img className="mx-auto block w-illustration-compact" src={ImageParty} alt="success" />
      </Modal.Body>
      <Modal.Actions>
        <Modal.Close>
          <Button variant="outline" onClick={() => void navigate(routes.bookings.list({ slug }))}>
            {t("common.action.close")}
          </Button>
        </Modal.Close>
        <Button onClick={() => void navigate({ pathname: routes.calendar.list({ slug }), search: "tab=reservations" })}>
          {t("page.bookings.book-asset.success-modal.see-details")}
        </Button>
      </Modal.Actions>
    </Modal.Root>
  );
}
